import cx from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '@bwoty-web/ui-kit';
import { useState } from 'react';

import HotelHitWrapper from '../shared/hotelHit/HotelHitWrapper';

import './alternativeHotels.scss';

const INITIAL_MAX_NUMBER_OF_HOTELS = 3;

const AlternativeHotels = ({
  hotels,
  transportData,
  searchInformation,
  alternativeHotelsLabels,
  labels,
  siteSettings,
}) => {
  const [showAllHotels, setShowAllHotels] = useState(false);

  const numberOfHotelsShown = showAllHotels
    ? hotels.length
    : INITIAL_MAX_NUMBER_OF_HOTELS;

  const showMoreClasses = cx('iw-price-matrix-alternative-hotels__show-more', {
    'iw-price-matrix-alternative-hotels__show-more--hidden':
      showAllHotels || hotels.length <= INITIAL_MAX_NUMBER_OF_HOTELS,
  });

  return (
    <div className="iw-price-matrix-alternative-hotels">
      <div className="iw-price-matrix-alternative-hotels__heading">
        {labels.alternativeHotelsHeading}
      </div>
      {hotels.slice(0, numberOfHotelsShown).map((hotel) => {
        return (
          <HotelHitWrapper
            data={hotel}
            transportInfo={transportData}
            labels={alternativeHotelsLabels}
            searchInformation={searchInformation}
            key={`alternativeHotel_${hotel?.id}`}
            siteSettings={siteSettings}
          />
        );
      })}
      <div className={showMoreClasses}>
        <Button
          data-gtm-tag="Show More Alternative Hotels"
          onClick={() => setShowAllHotels(true)}
        >
          {labels.showMoreButtonLabel}
        </Button>
      </div>
    </div>
  );
};

AlternativeHotels.propTypes = {
  hotels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  transportData: PropTypes.shape({}).isRequired,
  searchInformation: PropTypes.shape({}).isRequired,
  alternativeHotelsLabels: PropTypes.shape({}).isRequired,
  labels: PropTypes.shape({
    alternativeHotelsHeading: PropTypes.string,
    showMoreButtonLabel: PropTypes.string,
  }).isRequired,
  siteSettings: PropTypes.shape({}).isRequired,
};

export default AlternativeHotels;
